import React from "react";
import { Dealer } from "hooks/useDealers";
import { SkeletonCard } from "components/shared/SkeletonCard";
import {
  ActionButton,
  StatusBadge,
  DealerCard,
  DealerCardHeader,
  DealerCardTitle,
  DealerCardContent,
  DealerCardInfo,
  DealerCardInfoRow,
  DealerCardLabel,
  DealerCardValue,
  DealerCardActions,
  DealersGrid,
} from "styles/components/dealersList.styles";

interface DealersCardViewProps {
  dealers: Dealer[];
  isLoading: boolean;
  onCardClick: (dealer: Dealer) => void;
  onEnableDealer: (dealer: Dealer) => void;
  onDisableDealer: (dealer: Dealer) => void;
}

const DealersCardView: React.FC<DealersCardViewProps> = ({
  dealers,
  isLoading,
  onCardClick,
  onEnableDealer,
  onDisableDealer,
}) => {
  if (isLoading) {
    return (
      <DealersGrid role="status" aria-busy="true" aria-label="Loading dealers">
        {Array.from({ length: 4 }, (_, index) => (
          <SkeletonCard key={index} />
        ))}
      </DealersGrid>
    );
  }

  return (
    <DealersGrid>
      {dealers.map((dealer: Dealer) => (
        <DealerCard key={dealer.id} onClick={() => onCardClick(dealer)}>
          <DealerCardHeader>
            <DealerCardTitle>
              {dealer.firstName} {dealer.lastName}
            </DealerCardTitle>
            <StatusBadge status={dealer.disabled ? "disabled" : "active"}>
              {dealer.disabled ? "Disabled" : "Active"}
            </StatusBadge>
          </DealerCardHeader>

          <DealerCardContent>
            <DealerCardInfo>
              <DealerCardInfoRow>
                <DealerCardLabel>Dealer Name:</DealerCardLabel>
                <DealerCardValue>{dealer.dealerName || "N/A"}</DealerCardValue>
              </DealerCardInfoRow>
              <DealerCardInfoRow>
                <DealerCardLabel>Email:</DealerCardLabel>
                <DealerCardValue>{dealer.email}</DealerCardValue>
              </DealerCardInfoRow>
              <DealerCardInfoRow>
                <DealerCardLabel>Country:</DealerCardLabel>
                <DealerCardValue>{dealer.country || "N/A"}</DealerCardValue>
              </DealerCardInfoRow>
            </DealerCardInfo>
          </DealerCardContent>

          <DealerCardActions onClick={(e) => e.stopPropagation()}>
            {dealer.disabled ? (
              <ActionButton
                className="enable"
                onClick={() => onEnableDealer(dealer)}
              >
                <i className="pi pi-check-circle" /> Enable
              </ActionButton>
            ) : (
              <ActionButton
                className="disable"
                onClick={() => onDisableDealer(dealer)}
              >
                <i className="pi pi-ban" /> Disable
              </ActionButton>
            )}
          </DealerCardActions>
        </DealerCard>
      ))}
    </DealersGrid>
  );
};

export default DealersCardView;
